import { useCallback, useEffect } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { availableLanguages, i18n } from '../i18nRushB'

type Lang = keyof typeof availableLanguages

export const useI18nRoute = () => {
  const { lang } = useParams()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (!lang || !availableLanguages?.[lang as Lang]) {
      const queryString = searchParams.toString()
      const newPath = ['/en', queryString ? `?${queryString}` : ''].filter(Boolean).join('/')

      navigate(newPath, { replace: true }) // 语言不支持时跳转默认 en
      return
    }

    i18n.load(lang, availableLanguages[lang as Lang]) // 加载对应语言
    i18n.activate(lang)
  }, [lang, navigate, searchParams])
}

// Utility for creating language-aware paths
export const useLanguagePath = () => {
  const { lang } = useParams()
  const location = useLocation()
  const currentPath = location.pathname

  return useCallback(
    (path: string) => {
      // If the path is the current path, return it unchanged
      if (path === currentPath) return path

      // If path starts with slash but no language, add language
      if (path.startsWith('/') || !path) return `/${lang}${path}`

      // If path has no slash, add slash and language
      return `/${lang}/${path}`
    },
    [lang, currentPath],
  )
}
